export default __webpack_public_path__ + "static/media/nft2.6963f62e.jpg";